import React from 'react';
import isNumber from 'lodash/isNumber';
import Spinner from '../../../components/Spinner/Spinner';
import DashboardObjectivesFormField from './DashboardObjectivesFormField';
import './styles/DashboardObjectives.scss';

const DashboardObjectivesForm = ({ formValues, setFormValues, formErrors, setFormErrors, loading }) => {
  const onChangeField = (name, value, singleDecimal = false) => {
    let error = null;
    
    if (value === '') {
      error = 'Required value';
    } else {
      const numVal = Number(value);
      
      if (!isNumber(numVal)) {
        error = 'Value must be number';
      } else if (numVal <= 0) {
        error = 'Value must be positive';
      } else if (singleDecimal && !/^\d+(\.\d)?$/.test(numVal.toString())) {
        error = 'Only integers or single-decimal numbers';
      }
    }
  
    setFormValues(prev => ({ ...prev, [name]: value }));
    setFormErrors(prev => ({ ...prev, [name]: error }));
  };
  
  const onChangeWaste = value => {
    onChangeField('waste', value);
  };
  
  const onChangeStockout = value => {
    onChangeField('stockout', value, true);
  };
  
  const onChangeHoldTime = value => {
    onChangeField('holdTime', value);
  };
  
  return (
    <div className="dashboard-objectives-form">
      <div className="dashboard-objectives-form-header">
        <h3>Set Objectives</h3>
        {loading ? <Spinner /> : null}
      </div>
  
      <DashboardObjectivesFormField
        title="Speed of Service"
        description="Limiting the duration of stock outs prevents delays in assembling menu items/customer orders"
        placeholder="Acceptable Stock Out Avg Duration, min"
        value={formValues.stockout}
        error={formErrors.stockout}
        onChange={onChangeStockout}
        disabled={loading}
      />
  
      <DashboardObjectivesFormField
        title="Cost of Food"
        description="Keeping costs low helps the store better serve customers, team members, and all stakeholders"
        placeholder="Acceptable Waste, %"
        value={formValues.waste}
        error={formErrors.waste}
        onChange={onChangeWaste}
        disabled={loading}
      />
      
      <DashboardObjectivesFormField
        title="Taste of Food"
        description="Using materials sooner helps preserve freshness and improves the final product taste"
        placeholder="Acceptable Hold Times Perf (<= 20 min), %"
        value={formValues.holdTime}
        error={formErrors.holdTime}
        onChange={onChangeHoldTime}
        disabled={loading}
      />
    </div>
  );
};

export default DashboardObjectivesForm;